import {} from "./Checking.js";
export function createChecking() {
    return {
        substitution: new Map(),
        typeVarCounters: new Map(),
    };
}
//# sourceMappingURL=createChecking.js.map